export const SAMPLE_CONSTANT = 'SAMPLE_CONSTANT';
